module.exports = __webpack_public_path__ + "img/bjx_detail_car_01.8272c313.png";